import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { adminApi } from '../services/adminApi';

// Safe defaults used for non-admin users (backend enforces the real rules)
const DEFAULTS = {
  maintenance_mode: false,
  registration_enabled: true,
  upload_enabled: true,
  max_file_size_mb: 200,
  min_payout_amount_paise: 10000,
  min_payout_amount: 100,
  platform_fee_percentage: 5,
};

export const usePlatformSettings = () => {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loadingSettings, setLoadingSettings] = useState(true);
  const { isAdmin } = useSelector((state) => state.auth);

  useEffect(() => {
    // Only admins need the real values — everyone else gets defaults immediately.
    // This prevents 401s from non-admin users hitting the protected endpoint.
    if (!isAdmin) {
      setLoadingSettings(false);
      return;
    }
    fetchSettings();
  }, [isAdmin]);

  const fetchSettings = async () => {
    try {
      const response = await adminApi.getSettings();
      setSettings({
        ...DEFAULTS,
        ...response,
        min_payout_amount: (response?.min_payout_amount_paise ?? DEFAULTS.min_payout_amount_paise) / 100,
      });
    } catch (error) {
      console.error('Failed to fetch platform settings:', error);
      setSettings(DEFAULTS);
    } finally {
      setLoadingSettings(false);
    }
  };

  return { settings, loadingSettings, refetch: fetchSettings };
};
